export function download(url, title) {
	window.open(url, '_blank')
}

export default { download }